import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled from 'styled-components';
import { componentOperatorMap, FilterDataTypes } from '../utils';
import { DateFilterComponent } from './DateFilterComponent';
import { TimestampHandlerComponentFactory } from './TimestampHandlerComponentFactory';
import { PicklistFilterComponent } from './PicklistFilterComponent';
import { TextFilterComponent } from './TextFilterComponent';
export var FilterRow = styled.div.withConfig({
  displayName: "FilterComponentFactory__FilterRow",
  componentId: "qtmlle-0"
})(["display:flex;margin-bottom:1rem;>:first-child{flex:55%;margin-right:1rem;}>:last-child{flex:45%;}"]);
export var FilterComponentFactory = function FilterComponentFactory(_ref) {
  var type = _ref.type,
      props = _objectWithoutProperties(_ref, ["type"]);

  var componentProps = _objectSpread(_objectSpread({}, props), {}, {
    operators: componentOperatorMap[type]
  });

  var baseDsComponentProps = {
    e2e: props.e2e ? "".concat(props.e2e, "-").concat(props.stateKey, "-filter-field") : "".concat(props.stateKey, "-filter-field")
  };

  switch (type) {
    case FilterDataTypes.PICKLIST:
      return /*#__PURE__*/React.createElement(PicklistFilterComponent, _extends({}, componentProps, {
        dsComponentProps: _objectSpread({}, baseDsComponentProps)
      }));

    case FilterDataTypes.BIGINT:
    case FilterDataTypes.DECIMAL:
      return /*#__PURE__*/React.createElement(TextFilterComponent, _extends({}, componentProps, {
        dsComponentProps: _objectSpread({
          type: 'number'
        }, baseDsComponentProps)
      }));

    case FilterDataTypes.DATE:
      return /*#__PURE__*/React.createElement(DateFilterComponent, _extends({}, componentProps, {
        dsComponentProps: _objectSpread({}, baseDsComponentProps)
      }));

    case FilterDataTypes.TIMESTAMP:
      return /*#__PURE__*/React.createElement(TimestampHandlerComponentFactory, _extends({}, componentProps, {
        dsComponentProps: _objectSpread({}, baseDsComponentProps)
      }));

    case FilterDataTypes.STRING:
    default:
      return /*#__PURE__*/React.createElement(TextFilterComponent, _extends({}, componentProps, {
        dsComponentProps: _objectSpread({}, baseDsComponentProps)
      }));
  }
};

try {
  FilterRow.__docgenInfo = {
    description: '',
    displayName: 'FilterRow',
    methods: [],
    props: {
      onChange: {
        defaultValue: null,
        description: '',
        name: 'onChange',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      defaultChecked: {
        defaultValue: null,
        description: '',
        name: 'defaultChecked',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      defaultValue: {
        defaultValue: null,
        description: '',
        name: 'defaultValue',
        required: false,
        type: {
          name: 'string | number | readonly string[]'
        }
      },
      suppressContentEditableWarning: {
        defaultValue: null,
        description: '',
        name: 'suppressContentEditableWarning',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      suppressHydrationWarning: {
        defaultValue: null,
        description: '',
        name: 'suppressHydrationWarning',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      accessKey: {
        defaultValue: null,
        description: '',
        name: 'accessKey',
        required: false,
        type: {
          name: 'string'
        }
      },
      className: {
        defaultValue: null,
        description: '',
        name: 'className',
        required: false,
        type: {
          name: 'string'
        }
      },
      contentEditable: {
        defaultValue: null,
        description: '',
        name: 'contentEditable',
        required: false,
        type: {
          name: '"inherit" | Booleanish'
        }
      },
      contextMenu: {
        defaultValue: null,
        description: '',
        name: 'contextMenu',
        required: false,
        type: {
          name: 'string'
        }
      },
      dir: {
        defaultValue: null,
        description: '',
        name: 'dir',
        required: false,
        type: {
          name: 'string'
        }
      },
      draggable: {
        defaultValue: null,
        description: '',
        name: 'draggable',
        required: false,
        type: {
          name: 'Booleanish'
        }
      },
      hidden: {
        defaultValue: null,
        description: '',
        name: 'hidden',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      id: {
        defaultValue: null,
        description: '',
        name: 'id',
        required: false,
        type: {
          name: 'string'
        }
      },
      lang: {
        defaultValue: null,
        description: '',
        name: 'lang',
        required: false,
        type: {
          name: 'string'
        }
      },
      placeholder: {
        defaultValue: null,
        description: '',
        name: 'placeholder',
        required: false,
        type: {
          name: 'string'
        }
      },
      slot: {
        defaultValue: null,
        description: '',
        name: 'slot',
        required: false,
        type: {
          name: 'string'
        }
      },
      spellCheck: {
        defaultValue: null,
        description: '',
        name: 'spellCheck',
        required: false,
        type: {
          name: 'Booleanish'
        }
      },
      style: {
        defaultValue: null,
        description: '',
        name: 'style',
        required: false,
        type: {
          name: 'CSSProperties'
        }
      },
      tabIndex: {
        defaultValue: null,
        description: '',
        name: 'tabIndex',
        required: false,
        type: {
          name: 'number'
        }
      },
      title: {
        defaultValue: null,
        description: '',
        name: 'title',
        required: false,
        type: {
          name: 'string'
        }
      },
      translate: {
        defaultValue: null,
        description: '',
        name: 'translate',
        required: false,
        type: {
          name: 'enum',
          raw: '"yes" | "no"',
          value: [{
            value: '"yes"'
          }, {
            value: '"no"'
          }]
        }
      },
      radioGroup: {
        defaultValue: null,
        description: '',
        name: 'radioGroup',
        required: false,
        type: {
          name: 'string'
        }
      },
      role: {
        defaultValue: null,
        description: '',
        name: 'role',
        required: false,
        type: {
          name: 'string'
        }
      },
      about: {
        defaultValue: null,
        description: '',
        name: 'about',
        required: false,
        type: {
          name: 'string'
        }
      },
      datatype: {
        defaultValue: null,
        description: '',
        name: 'datatype',
        required: false,
        type: {
          name: 'string'
        }
      },
      inlist: {
        defaultValue: null,
        description: '',
        name: 'inlist',
        required: false,
        type: {
          name: 'any'
        }
      },
      prefix: {
        defaultValue: null,
        description: '',
        name: 'prefix',
        required: false,
        type: {
          name: 'string'
        }
      },
      property: {
        defaultValue: null,
        description: '',
        name: 'property',
        required: false,
        type: {
          name: 'string'
        }
      },
      resource: {
        defaultValue: null,
        description: '',
        name: 'resource',
        required: false,
        type: {
          name: 'string'
        }
      },
      typeof: {
        defaultValue: null,
        description: '',
        name: 'typeof',
        required: false,
        type: {
          name: 'string'
        }
      },
      vocab: {
        defaultValue: null,
        description: '',
        name: 'vocab',
        required: false,
        type: {
          name: 'string'
        }
      },
      autoCapitalize: {
        defaultValue: null,
        description: '',
        name: 'autoCapitalize',
        required: false,
        type: {
          name: 'string'
        }
      },
      autoCorrect: {
        defaultValue: null,
        description: '',
        name: 'autoCorrect',
        required: false,
        type: {
          name: 'string'
        }
      },
      autoSave: {
        defaultValue: null,
        description: '',
        name: 'autoSave',
        required: false,
        type: {
          name: 'string'
        }
      },
      color: {
        defaultValue: null,
        description: '',
        name: 'color',
        required: false,
        type: {
          name: 'string'
        }
      },
      itemProp: {
        defaultValue: null,
        description: '',
        name: 'itemProp',
        required: false,
        type: {
          name: 'string'
        }
      },
      itemScope: {
        defaultValue: null,
        description: '',
        name: 'itemScope',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      itemType: {
        defaultValue: null,
        description: '',
        name: 'itemType',
        required: false,
        type: {
          name: 'string'
        }
      },
      itemID: {
        defaultValue: null,
        description: '',
        name: 'itemID',
        required: false,
        type: {
          name: 'string'
        }
      },
      itemRef: {
        defaultValue: null,
        description: '',
        name: 'itemRef',
        required: false,
        type: {
          name: 'string'
        }
      },
      results: {
        defaultValue: null,
        description: '',
        name: 'results',
        required: false,
        type: {
          name: 'number'
        }
      },
      security: {
        defaultValue: null,
        description: '',
        name: 'security',
        required: false,
        type: {
          name: 'string'
        }
      },
      unselectable: {
        defaultValue: null,
        description: '',
        name: 'unselectable',
        required: false,
        type: {
          name: 'enum',
          raw: '"on" | "off"',
          value: [{
            value: '"on"'
          }, {
            value: '"off"'
          }]
        }
      },
      inputMode: {
        defaultValue: null,
        description: 'Hints at the type of data that might be entered by the user while editing the element or its contents\n' + '@see https ://html.spec.whatwg.org/multipage/interaction.html#input-modalities:-the-inputmode-attribute',
        name: 'inputMode',
        required: false,
        type: {
          name: 'enum',
          raw: '"text" | "none" | "tel" | "url" | "email" | "numeric" | "decimal" | "search"',
          value: [{
            value: '"text"'
          }, {
            value: '"none"'
          }, {
            value: '"tel"'
          }, {
            value: '"url"'
          }, {
            value: '"email"'
          }, {
            value: '"numeric"'
          }, {
            value: '"decimal"'
          }, {
            value: '"search"'
          }]
        }
      },
      is: {
        defaultValue: null,
        description: 'Specify that a standard HTML element should behave like a defined custom built-in element\n' + '@see https ://html.spec.whatwg.org/multipage/custom-elements.html#attr-is',
        name: 'is',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-activedescendant': {
        defaultValue: null,
        description: 'Identifies the currently active element when DOM focus is on a composite widget, textbox, group, or application.',
        name: 'aria-activedescendant',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-atomic': {
        defaultValue: null,
        description: 'Indicates whether assistive technologies will present all, or only parts of, the changed region based on the change notifications defined by the aria-relevant attribute.',
        name: 'aria-atomic',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-autocomplete': {
        defaultValue: null,
        description: "Indicates whether inputting text could trigger display of one or more predictions of the user's intended value for an input and specifies how predictions would be\n" + 'presented if they are made.',
        name: 'aria-autocomplete',
        required: false,
        type: {
          name: 'enum',
          raw: '"none" | "list" | "inline" | "both"',
          value: [{
            value: '"none"'
          }, {
            value: '"list"'
          }, {
            value: '"inline"'
          }, {
            value: '"both"'
          }]
        }
      },
      'aria-busy': {
        defaultValue: null,
        description: 'Indicates an element is being modified and that assistive technologies MAY want to wait until the modifications are complete before exposing them to the user.',
        name: 'aria-busy',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-checked': {
        defaultValue: null,
        description: 'Indicates the current "checked" state of checkboxes, radio buttons, and other widgets.\n' + '@see aria-pressed\n' + '@see aria-selected.',
        name: 'aria-checked',
        required: false,
        type: {
          name: 'boolean | "true" | "false" | "mixed"'
        }
      },
      'aria-colcount': {
        defaultValue: null,
        description: 'Defines the total number of columns in a table, grid, or treegrid.\n' + '@see aria-colindex.',
        name: 'aria-colcount',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-colindex': {
        defaultValue: null,
        description: "Defines an element's column index or position with respect to the total number of columns within a table, grid, or treegrid.\n" + '@see aria-colcount\n' + '@see aria-colspan.',
        name: 'aria-colindex',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-colspan': {
        defaultValue: null,
        description: 'Defines the number of columns spanned by a cell or gridcell within a table, grid, or treegrid.\n' + '@see aria-colindex\n' + '@see aria-rowspan.',
        name: 'aria-colspan',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-controls': {
        defaultValue: null,
        description: 'Identifies the element (or elements) whose contents or presence are controlled by the current element.\n' + '@see aria-owns.',
        name: 'aria-controls',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-current': {
        defaultValue: null,
        description: 'Indicates the element that represents the current item within a container or set of related elements.',
        name: 'aria-current',
        required: false,
        type: {
          name: 'boolean | "time" | "true" | "false" | "page" | "step" | "location" | "date"'
        }
      },
      'aria-describedby': {
        defaultValue: null,
        description: 'Identifies the element (or elements) that describes the object.\n' + '@see aria-labelledby',
        name: 'aria-describedby',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-details': {
        defaultValue: null,
        description: 'Identifies the element that provides a detailed, extended description for the object.\n' + '@see aria-describedby.',
        name: 'aria-details',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-disabled': {
        defaultValue: null,
        description: 'Indicates that the element is perceivable but disabled, so it is not editable or otherwise operable.\n' + '@see aria-hidden\n' + '@see aria-readonly.',
        name: 'aria-disabled',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-dropeffect': {
        defaultValue: null,
        description: 'Indicates what functions can be performed when a dragged object is released on the drop target.\n' + '@deprecated in ARIA 1.1',
        name: 'aria-dropeffect',
        required: false,
        type: {
          name: 'enum',
          raw: '"link" | "none" | "move" | "copy" | "execute" | "popup"',
          value: [{
            value: '"link"'
          }, {
            value: '"none"'
          }, {
            value: '"move"'
          }, {
            value: '"copy"'
          }, {
            value: '"execute"'
          }, {
            value: '"popup"'
          }]
        }
      },
      'aria-errormessage': {
        defaultValue: null,
        description: 'Identifies the element that provides an error message for the object.\n' + '@see aria-invalid\n' + '@see aria-describedby.',
        name: 'aria-errormessage',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-expanded': {
        defaultValue: null,
        description: 'Indicates whether the element, or another grouping element it controls, is currently expanded or collapsed.',
        name: 'aria-expanded',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-flowto': {
        defaultValue: null,
        description: "Identifies the next element (or elements) in an alternate reading order of content which, at the user's discretion,\n" + 'allows assistive technology to override the general default of reading in document source order.',
        name: 'aria-flowto',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-grabbed': {
        defaultValue: null,
        description: "Indicates an element's \"grabbed\" state in a drag-and-drop operation.\n" + '@deprecated in ARIA 1.1',
        name: 'aria-grabbed',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-haspopup': {
        defaultValue: null,
        description: 'Indicates the availability and type of interactive popup element, such as menu or dialog, that can be triggered by an element.',
        name: 'aria-haspopup',
        required: false,
        type: {
          name: 'boolean | "dialog" | "menu" | "true" | "false" | "listbox" | "tree" | "grid"'
        }
      },
      'aria-hidden': {
        defaultValue: null,
        description: 'Indicates whether the element is exposed to an accessibility API.\n' + '@see aria-disabled.',
        name: 'aria-hidden',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-invalid': {
        defaultValue: null,
        description: 'Indicates the entered value does not conform to the format expected by the application.\n' + '@see aria-errormessage.',
        name: 'aria-invalid',
        required: false,
        type: {
          name: 'boolean | "true" | "false" | "grammar" | "spelling"'
        }
      },
      'aria-keyshortcuts': {
        defaultValue: null,
        description: 'Indicates keyboard shortcuts that an author has implemented to activate or give focus to an element.',
        name: 'aria-keyshortcuts',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-label': {
        defaultValue: null,
        description: 'Defines a string value that labels the current element.\n' + '@see aria-labelledby.',
        name: 'aria-label',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-labelledby': {
        defaultValue: null,
        description: 'Identifies the element (or elements) that labels the current element.\n' + '@see aria-describedby.',
        name: 'aria-labelledby',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-level': {
        defaultValue: null,
        description: 'Defines the hierarchical level of an element within a structure.',
        name: 'aria-level',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-live': {
        defaultValue: null,
        description: 'Indicates that an element will be updated, and describes the types of updates the user agents, assistive technologies, and user can expect from the live region.',
        name: 'aria-live',
        required: false,
        type: {
          name: 'enum',
          raw: '"off" | "assertive" | "polite"',
          value: [{
            value: '"off"'
          }, {
            value: '"assertive"'
          }, {
            value: '"polite"'
          }]
        }
      },
      'aria-modal': {
        defaultValue: null,
        description: 'Indicates whether an element is modal when displayed.',
        name: 'aria-modal',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-multiline': {
        defaultValue: null,
        description: 'Indicates whether a text box accepts multiple lines of input or only a single line.',
        name: 'aria-multiline',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-multiselectable': {
        defaultValue: null,
        description: 'Indicates that the user may select more than one item from the current selectable descendants.',
        name: 'aria-multiselectable',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-orientation': {
        defaultValue: null,
        description: "Indicates whether the element's orientation is horizontal, vertical, or unknown/ambiguous.",
        name: 'aria-orientation',
        required: false,
        type: {
          name: 'enum',
          raw: '"horizontal" | "vertical"',
          value: [{
            value: '"horizontal"'
          }, {
            value: '"vertical"'
          }]
        }
      },
      'aria-owns': {
        defaultValue: null,
        description: 'Identifies an element (or elements) in order to define a visual, functional, or contextual parent/child relationship\n' + 'between DOM elements where the DOM hierarchy cannot be used to represent the relationship.\n' + '@see aria-controls.',
        name: 'aria-owns',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-placeholder': {
        defaultValue: null,
        description: 'Defines a short hint (a word or short phrase) intended to aid the user with data entry when the control has no value.\n' + 'A hint could be a sample value or a brief description of the expected format.',
        name: 'aria-placeholder',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-posinset': {
        defaultValue: null,
        description: "Defines an element's number or position in the current set of listitems or treeitems. Not required if all elements in the set are present in the DOM.\n" + '@see aria-setsize.',
        name: 'aria-posinset',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-pressed': {
        defaultValue: null,
        description: 'Indicates the current "pressed" state of toggle buttons.\n' + '@see aria-checked\n' + '@see aria-selected.',
        name: 'aria-pressed',
        required: false,
        type: {
          name: 'boolean | "true" | "false" | "mixed"'
        }
      },
      'aria-readonly': {
        defaultValue: null,
        description: 'Indicates that the element is not editable, but is otherwise operable.\n' + '@see aria-disabled.',
        name: 'aria-readonly',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-relevant': {
        defaultValue: null,
        description: 'Indicates what notifications the user agent will trigger when the accessibility tree within a live region is modified.\n' + '@see aria-atomic.',
        name: 'aria-relevant',
        required: false,
        type: {
          name: 'enum',
          raw: '"text" | "additions" | "additions removals" | "additions text" | "all" | "removals" | "removals additions" | "removals text" | "text additions" | "text removals"',
          value: [{
            value: '"text"'
          }, {
            value: '"additions"'
          }, {
            value: '"additions removals"'
          }, {
            value: '"additions text"'
          }, {
            value: '"all"'
          }, {
            value: '"removals"'
          }, {
            value: '"removals additions"'
          }, {
            value: '"removals text"'
          }, {
            value: '"text additions"'
          }, {
            value: '"text removals"'
          }]
        }
      },
      'aria-required': {
        defaultValue: null,
        description: 'Indicates that user input is required on the element before a form may be submitted.',
        name: 'aria-required',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-roledescription': {
        defaultValue: null,
        description: 'Defines a human-readable, author-localized description for the role of an element.',
        name: 'aria-roledescription',
        required: false,
        type: {
          name: 'string'
        }
      },
      'aria-rowcount': {
        defaultValue: null,
        description: 'Defines the total number of rows in a table, grid, or treegrid.\n' + '@see aria-rowindex.',
        name: 'aria-rowcount',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-rowindex': {
        defaultValue: null,
        description: "Defines an element's row index or position with respect to the total number of rows within a table, grid, or treegrid.\n" + '@see aria-rowcount\n' + '@see aria-rowspan.',
        name: 'aria-rowindex',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-rowspan': {
        defaultValue: null,
        description: 'Defines the number of rows spanned by a cell or gridcell within a table, grid, or treegrid.\n' + '@see aria-rowindex\n' + '@see aria-colspan.',
        name: 'aria-rowspan',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-selected': {
        defaultValue: null,
        description: 'Indicates the current "selected" state of various widgets.\n' + '@see aria-checked\n' + '@see aria-pressed.',
        name: 'aria-selected',
        required: false,
        type: {
          name: 'boolean | "true" | "false"'
        }
      },
      'aria-setsize': {
        defaultValue: null,
        description: 'Defines the number of items in the current set of listitems or treeitems. Not required if all elements in the set are present in the DOM.\n' + '@see aria-posinset.',
        name: 'aria-setsize',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-sort': {
        defaultValue: null,
        description: 'Indicates if items in a table or grid are sorted in ascending or descending order.',
        name: 'aria-sort',
        required: false,
        type: {
          name: 'enum',
          raw: '"none" | "ascending" | "descending" | "other"',
          value: [{
            value: '"none"'
          }, {
            value: '"ascending"'
          }, {
            value: '"descending"'
          }, {
            value: '"other"'
          }]
        }
      },
      'aria-valuemax': {
        defaultValue: null,
        description: 'Defines the maximum allowed value for a range widget.',
        name: 'aria-valuemax',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-valuemin': {
        defaultValue: null,
        description: 'Defines the minimum allowed value for a range widget.',
        name: 'aria-valuemin',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-valuenow': {
        defaultValue: null,
        description: 'Defines the current value for a range widget.\n@see aria-valuetext.',
        name: 'aria-valuenow',
        required: false,
        type: {
          name: 'number'
        }
      },
      'aria-valuetext': {
        defaultValue: null,
        description: 'Defines the human readable text alternative of aria-valuenow for a range widget.',
        name: 'aria-valuetext',
        required: false,
        type: {
          name: 'string'
        }
      },
      dangerouslySetInnerHTML: {
        defaultValue: null,
        description: '',
        name: 'dangerouslySetInnerHTML',
        required: false,
        type: {
          name: '{ __html: string; }'
        }
      },
      onCopy: {
        defaultValue: null,
        description: '',
        name: 'onCopy',
        required: false,
        type: {
          name: 'ClipboardEventHandler<HTMLDivElement>'
        }
      },
      onCopyCapture: {
        defaultValue: null,
        description: '',
        name: 'onCopyCapture',
        required: false,
        type: {
          name: 'ClipboardEventHandler<HTMLDivElement>'
        }
      },
      onCut: {
        defaultValue: null,
        description: '',
        name: 'onCut',
        required: false,
        type: {
          name: 'ClipboardEventHandler<HTMLDivElement>'
        }
      },
      onCutCapture: {
        defaultValue: null,
        description: '',
        name: 'onCutCapture',
        required: false,
        type: {
          name: 'ClipboardEventHandler<HTMLDivElement>'
        }
      },
      onPaste: {
        defaultValue: null,
        description: '',
        name: 'onPaste',
        required: false,
        type: {
          name: 'ClipboardEventHandler<HTMLDivElement>'
        }
      },
      onPasteCapture: {
        defaultValue: null,
        description: '',
        name: 'onPasteCapture',
        required: false,
        type: {
          name: 'ClipboardEventHandler<HTMLDivElement>'
        }
      },
      onCompositionEnd: {
        defaultValue: null,
        description: '',
        name: 'onCompositionEnd',
        required: false,
        type: {
          name: 'CompositionEventHandler<HTMLDivElement>'
        }
      },
      onCompositionEndCapture: {
        defaultValue: null,
        description: '',
        name: 'onCompositionEndCapture',
        required: false,
        type: {
          name: 'CompositionEventHandler<HTMLDivElement>'
        }
      },
      onCompositionStart: {
        defaultValue: null,
        description: '',
        name: 'onCompositionStart',
        required: false,
        type: {
          name: 'CompositionEventHandler<HTMLDivElement>'
        }
      },
      onCompositionStartCapture: {
        defaultValue: null,
        description: '',
        name: 'onCompositionStartCapture',
        required: false,
        type: {
          name: 'CompositionEventHandler<HTMLDivElement>'
        }
      },
      onCompositionUpdate: {
        defaultValue: null,
        description: '',
        name: 'onCompositionUpdate',
        required: false,
        type: {
          name: 'CompositionEventHandler<HTMLDivElement>'
        }
      },
      onCompositionUpdateCapture: {
        defaultValue: null,
        description: '',
        name: 'onCompositionUpdateCapture',
        required: false,
        type: {
          name: 'CompositionEventHandler<HTMLDivElement>'
        }
      },
      onFocus: {
        defaultValue: null,
        description: '',
        name: 'onFocus',
        required: false,
        type: {
          name: 'FocusEventHandler<HTMLDivElement>'
        }
      },
      onFocusCapture: {
        defaultValue: null,
        description: '',
        name: 'onFocusCapture',
        required: false,
        type: {
          name: 'FocusEventHandler<HTMLDivElement>'
        }
      },
      onBlur: {
        defaultValue: null,
        description: '',
        name: 'onBlur',
        required: false,
        type: {
          name: 'FocusEventHandler<HTMLDivElement>'
        }
      },
      onBlurCapture: {
        defaultValue: null,
        description: '',
        name: 'onBlurCapture',
        required: false,
        type: {
          name: 'FocusEventHandler<HTMLDivElement>'
        }
      },
      onChangeCapture: {
        defaultValue: null,
        description: '',
        name: 'onChangeCapture',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onBeforeInput: {
        defaultValue: null,
        description: '',
        name: 'onBeforeInput',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onBeforeInputCapture: {
        defaultValue: null,
        description: '',
        name: 'onBeforeInputCapture',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onInput: {
        defaultValue: null,
        description: '',
        name: 'onInput',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onInputCapture: {
        defaultValue: null,
        description: '',
        name: 'onInputCapture',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onReset: {
        defaultValue: null,
        description: '',
        name: 'onReset',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onResetCapture: {
        defaultValue: null,
        description: '',
        name: 'onResetCapture',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onSubmit: {
        defaultValue: null,
        description: '',
        name: 'onSubmit',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onSubmitCapture: {
        defaultValue: null,
        description: '',
        name: 'onSubmitCapture',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onInvalid: {
        defaultValue: null,
        description: '',
        name: 'onInvalid',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onInvalidCapture: {
        defaultValue: null,
        description: '',
        name: 'onInvalidCapture',
        required: false,
        type: {
          name: 'FormEventHandler<HTMLDivElement>'
        }
      },
      onLoad: {
        defaultValue: null,
        description: '',
        name: 'onLoad',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onLoadCapture: {
        defaultValue: null,
        description: '',
        name: 'onLoadCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onError: {
        defaultValue: null,
        description: '',
        name: 'onError',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onErrorCapture: {
        defaultValue: null,
        description: '',
        name: 'onErrorCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onKeyDown: {
        defaultValue: null,
        description: '',
        name: 'onKeyDown',
        required: false,
        type: {
          name: 'KeyboardEventHandler<HTMLDivElement>'
        }
      },
      onKeyDownCapture: {
        defaultValue: null,
        description: '',
        name: 'onKeyDownCapture',
        required: false,
        type: {
          name: 'KeyboardEventHandler<HTMLDivElement>'
        }
      },
      onKeyPress: {
        defaultValue: null,
        description: '',
        name: 'onKeyPress',
        required: false,
        type: {
          name: 'KeyboardEventHandler<HTMLDivElement>'
        }
      },
      onKeyPressCapture: {
        defaultValue: null,
        description: '',
        name: 'onKeyPressCapture',
        required: false,
        type: {
          name: 'KeyboardEventHandler<HTMLDivElement>'
        }
      },
      onKeyUp: {
        defaultValue: null,
        description: '',
        name: 'onKeyUp',
        required: false,
        type: {
          name: 'KeyboardEventHandler<HTMLDivElement>'
        }
      },
      onKeyUpCapture: {
        defaultValue: null,
        description: '',
        name: 'onKeyUpCapture',
        required: false,
        type: {
          name: 'KeyboardEventHandler<HTMLDivElement>'
        }
      },
      onAbort: {
        defaultValue: null,
        description: '',
        name: 'onAbort',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onAbortCapture: {
        defaultValue: null,
        description: '',
        name: 'onAbortCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onCanPlay: {
        defaultValue: null,
        description: '',
        name: 'onCanPlay',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onCanPlayCapture: {
        defaultValue: null,
        description: '',
        name: 'onCanPlayCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onCanPlayThrough: {
        defaultValue: null,
        description: '',
        name: 'onCanPlayThrough',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onCanPlayThroughCapture: {
        defaultValue: null,
        description: '',
        name: 'onCanPlayThroughCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onDurationChange: {
        defaultValue: null,
        description: '',
        name: 'onDurationChange',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onDurationChangeCapture: {
        defaultValue: null,
        description: '',
        name: 'onDurationChangeCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onEmptied: {
        defaultValue: null,
        description: '',
        name: 'onEmptied',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onEmptiedCapture: {
        defaultValue: null,
        description: '',
        name: 'onEmptiedCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onEncrypted: {
        defaultValue: null,
        description: '',
        name: 'onEncrypted',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onEncryptedCapture: {
        defaultValue: null,
        description: '',
        name: 'onEncryptedCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onEnded: {
        defaultValue: null,
        description: '',
        name: 'onEnded',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onEndedCapture: {
        defaultValue: null,
        description: '',
        name: 'onEndedCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onLoadedData: {
        defaultValue: null,
        description: '',
        name: 'onLoadedData',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onLoadedDataCapture: {
        defaultValue: null,
        description: '',
        name: 'onLoadedDataCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onLoadedMetadata: {
        defaultValue: null,
        description: '',
        name: 'onLoadedMetadata',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onLoadedMetadataCapture: {
        defaultValue: null,
        description: '',
        name: 'onLoadedMetadataCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onLoadStart: {
        defaultValue: null,
        description: '',
        name: 'onLoadStart',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onLoadStartCapture: {
        defaultValue: null,
        description: '',
        name: 'onLoadStartCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onPause: {
        defaultValue: null,
        description: '',
        name: 'onPause',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onPauseCapture: {
        defaultValue: null,
        description: '',
        name: 'onPauseCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onPlay: {
        defaultValue: null,
        description: '',
        name: 'onPlay',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onPlayCapture: {
        defaultValue: null,
        description: '',
        name: 'onPlayCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onPlaying: {
        defaultValue: null,
        description: '',
        name: 'onPlaying',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onPlayingCapture: {
        defaultValue: null,
        description: '',
        name: 'onPlayingCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onProgress: {
        defaultValue: null,
        description: '',
        name: 'onProgress',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onProgressCapture: {
        defaultValue: null,
        description: '',
        name: 'onProgressCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onRateChange: {
        defaultValue: null,
        description: '',
        name: 'onRateChange',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onRateChangeCapture: {
        defaultValue: null,
        description: '',
        name: 'onRateChangeCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onSeeked: {
        defaultValue: null,
        description: '',
        name: 'onSeeked',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onSeekedCapture: {
        defaultValue: null,
        description: '',
        name: 'onSeekedCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onSeeking: {
        defaultValue: null,
        description: '',
        name: 'onSeeking',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onSeekingCapture: {
        defaultValue: null,
        description: '',
        name: 'onSeekingCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onStalled: {
        defaultValue: null,
        description: '',
        name: 'onStalled',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onStalledCapture: {
        defaultValue: null,
        description: '',
        name: 'onStalledCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onSuspend: {
        defaultValue: null,
        description: '',
        name: 'onSuspend',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onSuspendCapture: {
        defaultValue: null,
        description: '',
        name: 'onSuspendCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onTimeUpdate: {
        defaultValue: null,
        description: '',
        name: 'onTimeUpdate',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onTimeUpdateCapture: {
        defaultValue: null,
        description: '',
        name: 'onTimeUpdateCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onVolumeChange: {
        defaultValue: null,
        description: '',
        name: 'onVolumeChange',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onVolumeChangeCapture: {
        defaultValue: null,
        description: '',
        name: 'onVolumeChangeCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onWaiting: {
        defaultValue: null,
        description: '',
        name: 'onWaiting',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onWaitingCapture: {
        defaultValue: null,
        description: '',
        name: 'onWaitingCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onAuxClick: {
        defaultValue: null,
        description: '',
        name: 'onAuxClick',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onAuxClickCapture: {
        defaultValue: null,
        description: '',
        name: 'onAuxClickCapture',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onClick: {
        defaultValue: null,
        description: '',
        name: 'onClick',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onClickCapture: {
        defaultValue: null,
        description: '',
        name: 'onClickCapture',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onContextMenu: {
        defaultValue: null,
        description: '',
        name: 'onContextMenu',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onContextMenuCapture: {
        defaultValue: null,
        description: '',
        name: 'onContextMenuCapture',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onDoubleClick: {
        defaultValue: null,
        description: '',
        name: 'onDoubleClick',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onDoubleClickCapture: {
        defaultValue: null,
        description: '',
        name: 'onDoubleClickCapture',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onDrag: {
        defaultValue: null,
        description: '',
        name: 'onDrag',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragCapture: {
        defaultValue: null,
        description: '',
        name: 'onDragCapture',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragEnd: {
        defaultValue: null,
        description: '',
        name: 'onDragEnd',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragEndCapture: {
        defaultValue: null,
        description: '',
        name: 'onDragEndCapture',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragEnter: {
        defaultValue: null,
        description: '',
        name: 'onDragEnter',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragEnterCapture: {
        defaultValue: null,
        description: '',
        name: 'onDragEnterCapture',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragExit: {
        defaultValue: null,
        description: '',
        name: 'onDragExit',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragExitCapture: {
        defaultValue: null,
        description: '',
        name: 'onDragExitCapture',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragLeave: {
        defaultValue: null,
        description: '',
        name: 'onDragLeave',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragLeaveCapture: {
        defaultValue: null,
        description: '',
        name: 'onDragLeaveCapture',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragOver: {
        defaultValue: null,
        description: '',
        name: 'onDragOver',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragOverCapture: {
        defaultValue: null,
        description: '',
        name: 'onDragOverCapture',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragStart: {
        defaultValue: null,
        description: '',
        name: 'onDragStart',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDragStartCapture: {
        defaultValue: null,
        description: '',
        name: 'onDragStartCapture',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDrop: {
        defaultValue: null,
        description: '',
        name: 'onDrop',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onDropCapture: {
        defaultValue: null,
        description: '',
        name: 'onDropCapture',
        required: false,
        type: {
          name: 'DragEventHandler<HTMLDivElement>'
        }
      },
      onMouseDown: {
        defaultValue: null,
        description: '',
        name: 'onMouseDown',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseDownCapture: {
        defaultValue: null,
        description: '',
        name: 'onMouseDownCapture',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseEnter: {
        defaultValue: null,
        description: '',
        name: 'onMouseEnter',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseLeave: {
        defaultValue: null,
        description: '',
        name: 'onMouseLeave',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseMove: {
        defaultValue: null,
        description: '',
        name: 'onMouseMove',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseMoveCapture: {
        defaultValue: null,
        description: '',
        name: 'onMouseMoveCapture',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseOut: {
        defaultValue: null,
        description: '',
        name: 'onMouseOut',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseOutCapture: {
        defaultValue: null,
        description: '',
        name: 'onMouseOutCapture',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseOver: {
        defaultValue: null,
        description: '',
        name: 'onMouseOver',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseOverCapture: {
        defaultValue: null,
        description: '',
        name: 'onMouseOverCapture',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseUp: {
        defaultValue: null,
        description: '',
        name: 'onMouseUp',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onMouseUpCapture: {
        defaultValue: null,
        description: '',
        name: 'onMouseUpCapture',
        required: false,
        type: {
          name: 'MouseEventHandler<HTMLDivElement>'
        }
      },
      onSelect: {
        defaultValue: null,
        description: '',
        name: 'onSelect',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onSelectCapture: {
        defaultValue: null,
        description: '',
        name: 'onSelectCapture',
        required: false,
        type: {
          name: 'ReactEventHandler<HTMLDivElement>'
        }
      },
      onTouchCancel: {
        defaultValue: null,
        description: '',
        name: 'onTouchCancel',
        required: false,
        type: {
          name: 'TouchEventHandler<HTMLDivElement>'
        }
      },
      onTouchCancelCapture: {
        defaultValue: null,
        description: '',
        name: 'onTouchCancelCapture',
        required: false,
        type: {
          name: 'TouchEventHandler<HTMLDivElement>'
        }
      },
      onTouchEnd: {
        defaultValue: null,
        description: '',
        name: 'onTouchEnd',
        required: false,
        type: {
          name: 'TouchEventHandler<HTMLDivElement>'
        }
      },
      onTouchEndCapture: {
        defaultValue: null,
        description: '',
        name: 'onTouchEndCapture',
        required: false,
        type: {
          name: 'TouchEventHandler<HTMLDivElement>'
        }
      },
      onTouchMove: {
        defaultValue: null,
        description: '',
        name: 'onTouchMove',
        required: false,
        type: {
          name: 'TouchEventHandler<HTMLDivElement>'
        }
      },
      onTouchMoveCapture: {
        defaultValue: null,
        description: '',
        name: 'onTouchMoveCapture',
        required: false,
        type: {
          name: 'TouchEventHandler<HTMLDivElement>'
        }
      },
      onTouchStart: {
        defaultValue: null,
        description: '',
        name: 'onTouchStart',
        required: false,
        type: {
          name: 'TouchEventHandler<HTMLDivElement>'
        }
      },
      onTouchStartCapture: {
        defaultValue: null,
        description: '',
        name: 'onTouchStartCapture',
        required: false,
        type: {
          name: 'TouchEventHandler<HTMLDivElement>'
        }
      },
      onPointerDown: {
        defaultValue: null,
        description: '',
        name: 'onPointerDown',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerDownCapture: {
        defaultValue: null,
        description: '',
        name: 'onPointerDownCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerMove: {
        defaultValue: null,
        description: '',
        name: 'onPointerMove',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerMoveCapture: {
        defaultValue: null,
        description: '',
        name: 'onPointerMoveCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerUp: {
        defaultValue: null,
        description: '',
        name: 'onPointerUp',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerUpCapture: {
        defaultValue: null,
        description: '',
        name: 'onPointerUpCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerCancel: {
        defaultValue: null,
        description: '',
        name: 'onPointerCancel',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerCancelCapture: {
        defaultValue: null,
        description: '',
        name: 'onPointerCancelCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerEnter: {
        defaultValue: null,
        description: '',
        name: 'onPointerEnter',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerEnterCapture: {
        defaultValue: null,
        description: '',
        name: 'onPointerEnterCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerLeave: {
        defaultValue: null,
        description: '',
        name: 'onPointerLeave',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerLeaveCapture: {
        defaultValue: null,
        description: '',
        name: 'onPointerLeaveCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerOver: {
        defaultValue: null,
        description: '',
        name: 'onPointerOver',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerOverCapture: {
        defaultValue: null,
        description: '',
        name: 'onPointerOverCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerOut: {
        defaultValue: null,
        description: '',
        name: 'onPointerOut',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onPointerOutCapture: {
        defaultValue: null,
        description: '',
        name: 'onPointerOutCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onGotPointerCapture: {
        defaultValue: null,
        description: '',
        name: 'onGotPointerCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onGotPointerCaptureCapture: {
        defaultValue: null,
        description: '',
        name: 'onGotPointerCaptureCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onLostPointerCapture: {
        defaultValue: null,
        description: '',
        name: 'onLostPointerCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onLostPointerCaptureCapture: {
        defaultValue: null,
        description: '',
        name: 'onLostPointerCaptureCapture',
        required: false,
        type: {
          name: 'PointerEventHandler<HTMLDivElement>'
        }
      },
      onScroll: {
        defaultValue: null,
        description: '',
        name: 'onScroll',
        required: false,
        type: {
          name: 'UIEventHandler<HTMLDivElement>'
        }
      },
      onScrollCapture: {
        defaultValue: null,
        description: '',
        name: 'onScrollCapture',
        required: false,
        type: {
          name: 'UIEventHandler<HTMLDivElement>'
        }
      },
      onWheel: {
        defaultValue: null,
        description: '',
        name: 'onWheel',
        required: false,
        type: {
          name: 'WheelEventHandler<HTMLDivElement>'
        }
      },
      onWheelCapture: {
        defaultValue: null,
        description: '',
        name: 'onWheelCapture',
        required: false,
        type: {
          name: 'WheelEventHandler<HTMLDivElement>'
        }
      },
      onAnimationStart: {
        defaultValue: null,
        description: '',
        name: 'onAnimationStart',
        required: false,
        type: {
          name: 'AnimationEventHandler<HTMLDivElement>'
        }
      },
      onAnimationStartCapture: {
        defaultValue: null,
        description: '',
        name: 'onAnimationStartCapture',
        required: false,
        type: {
          name: 'AnimationEventHandler<HTMLDivElement>'
        }
      },
      onAnimationEnd: {
        defaultValue: null,
        description: '',
        name: 'onAnimationEnd',
        required: false,
        type: {
          name: 'AnimationEventHandler<HTMLDivElement>'
        }
      },
      onAnimationEndCapture: {
        defaultValue: null,
        description: '',
        name: 'onAnimationEndCapture',
        required: false,
        type: {
          name: 'AnimationEventHandler<HTMLDivElement>'
        }
      },
      onAnimationIteration: {
        defaultValue: null,
        description: '',
        name: 'onAnimationIteration',
        required: false,
        type: {
          name: 'AnimationEventHandler<HTMLDivElement>'
        }
      },
      onAnimationIterationCapture: {
        defaultValue: null,
        description: '',
        name: 'onAnimationIterationCapture',
        required: false,
        type: {
          name: 'AnimationEventHandler<HTMLDivElement>'
        }
      },
      onTransitionEnd: {
        defaultValue: null,
        description: '',
        name: 'onTransitionEnd',
        required: false,
        type: {
          name: 'TransitionEventHandler<HTMLDivElement>'
        }
      },
      onTransitionEndCapture: {
        defaultValue: null,
        description: '',
        name: 'onTransitionEndCapture',
        required: false,
        type: {
          name: 'TransitionEventHandler<HTMLDivElement>'
        }
      },
      ref: {
        defaultValue: null,
        description: '',
        name: 'ref',
        required: false,
        type: {
          name: 'Ref<HTMLDivElement>'
        }
      },
      key: {
        defaultValue: null,
        description: '',
        name: 'key',
        required: false,
        type: {
          name: 'Key'
        }
      },
      theme: {
        defaultValue: null,
        description: '',
        name: 'theme',
        required: false,
        type: {
          name: 'any'
        }
      },
      as: {
        defaultValue: null,
        description: '',
        name: 'as',
        required: false,
        type: {
          name: 'never'
        }
      },
      forwardedAs: {
        defaultValue: null,
        description: '',
        name: 'forwardedAs',
        required: false,
        type: {
          name: 'never'
        }
      }
    }
  };
} catch (e) {}

try {
  FilterComponentFactory.__docgenInfo = {
    description: '',
    displayName: 'FilterComponentFactory',
    methods: [],
    props: {
      type: {
        defaultValue: null,
        description: '',
        name: 'type',
        required: true,
        type: {
          name: 'any'
        }
      },
      stateKey: {
        defaultValue: null,
        description: '',
        name: 'stateKey',
        required: true,
        type: {
          name: 'string'
        }
      },
      state: {
        defaultValue: null,
        description: '',
        name: 'state',
        required: true,
        type: {
          name: 'any'
        }
      },
      stateChangeFn: {
        defaultValue: null,
        description: '',
        name: 'stateChangeFn',
        required: true,
        type: {
          name: '(value: any) => void'
        }
      },
      operators: {
        defaultValue: null,
        description: '',
        name: 'operators',
        required: false,
        type: {
          name: 'string[]'
        }
      },
      dsComponentProps: {
        defaultValue: null,
        description: '',
        name: 'dsComponentProps',
        required: false,
        type: {
          name: 'any'
        }
      },
      filterableField: {
        defaultValue: null,
        description: '',
        name: 'filterableField',
        required: false,
        type: {
          name: 'any'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=FilterComponentFactory.js.map